<template>
    <LovCountryLayout :country="country">
        <DCard
            padding
        >
            <Form
                :country="country"
                :only-show-form="true"
                :currency-codes="currencyCodes"
            />
        </DCard>

        <DFabs>
            <DFab
                id="btn-edit"
                icon="pencil"
                :label="__('settings.countries.edit_country_button')"
                @click="editCountryObject"
            />
        </DFabs>
    </LovCountryLayout>
</template>

<script setup>
import Form from '~@/Components/Settings/Countries/Form'
import LovCountryLayout from '../Lov/LovCountryLayout.vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    country: {
        type: Object,
        default: () => ({})
    },
    currencyCodes: {
        type: Array,
        default: () => []
    }
})

const editCountryObject = () => router.get(route('settings.countries.edit', { country: props.country.country_code }))
</script>
